import { INDEX_COLORS } from './constants';

export const getBenchmarkColor = (benchmark: string | undefined): string => {
  if (!benchmark) return '#000';

  const _benchmark = benchmark?.split(':')?.[0];
  const color = INDEX_COLORS[_benchmark];

  return color || '#000';
};
